import React from "react";
import i18n from '../../../config/I18n';
import IcnCerrarModalfrom from '../../assets/svg/icnCerrarModal.svg';
import ButtonBase from '../button/ButtonBase';
import "./visor.css";

function VisorPDF({ setFile, disableFile, close, visorPDF }) {
  return (
    <>
      {disableFile && (
        <div className="Modal ModalVisor">
          <div className="Modal__container">
            <div className="modal">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <h2 className="titleModal mtop10"><strong>{i18n.t('modalDocumentos.revisar')}</strong></h2>
                    <ButtonBase
                      icons={IcnCerrarModalfrom}
                      callClick={()=> close()}
                      css="salir"
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div className="container visor">
                {setFile && (
                  <div className="visorStyles">
                    {visorPDF ? (
                      <embed src={setFile} type="application/pdf" width='100%' height='95%' />
                    ):(
                      <img src={setFile} width="600" alt="Doc" />
                    )}
                    
                  </div>
                )}
              </div>
              <div className="container pbottom0">
                <div className="row">
                  <div className="col-sm-12 col-md-8 col-lg-8" />
                  <div className="col-sm-12 col-md-4 col-lg-4 no-gutters mbottom15">
                    <ButtonBase
                      etiqueta={i18n.t('modalDocumentos.cerrar')}
                      css='blue'
                      callClick={()=> close()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VisorPDF;
